import { gql } from '@apollo/client';

export const AUTHENTICATED_QUERY = gql`
  query Authenticated {
    authenticated {
      success
      me {
        name
        email
        scopes
        createdAt
      }
      redirect @client
    }
  }
`;
